/**
 * Route for `auto-pause-campaign-when-threshold-hit`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AutoPauseCampaignWhenThresholdHitPage } from "../features/auto-pause-campaign-when-threshold-hit/AutoPauseCampaignWhenThresholdHitPage";

export const autoPauseCampaignWhenThresholdHitRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/auto-pause-campaign-when-threshold-hit",
	component: AutoPauseCampaignWhenThresholdHitPage,
});

export default autoPauseCampaignWhenThresholdHitRoute;
